<template>
  <ul
    class="grid-list-double-reels"
    :class="{
      '--not-by-3-even-4':
        list.length === 4 && list.length % 3 !== 0 && list.length % 2 === 0,
      '--not-by-3-even':
        list.length > 4 && list.length % 3 !== 0 && list.length % 2 === 0,
      '--not-by-3-odd':
        list.length > 3 && list.length % 3 !== 0 && list.length % 2 !== 0,
    }"
  >
    <li
      v-for="(item, index) in list"
      :key="index"
      class="grid-list-double-reels__item"
    >
      <PagesReelsGridListBlock
        :order="index"
        :item="item"
        :link-route="linkRoute"
        :alternative="alternative"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'PagesReelsGridList',
}
</script>

<script setup>
const props = defineProps({
  list: Array,
  linkRoute: String,
  alternative: Boolean,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
